import { render, staticRenderFns } from "./UdeEvent.vue?vue&type=template&id=37ff3a79&scoped=true"
import script from "./UdeEvent.vue?vue&type=script&lang=js"
export * from "./UdeEvent.vue?vue&type=script&lang=js"
import style0 from "./UdeEvent.vue?vue&type=style&index=0&id=37ff3a79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff3a79",
  null
  
)

export default component.exports